var _rect, _g, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPortalMenuHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 72,
    viewBox: "0 0 223 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_240_9570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 223,
    height: 72
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 223,
    height: 72,
    fill: "#056831"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_240_9570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223,
    height: 72,
    fill: "var(--ui-primary)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_240_9570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.167 23.0004C270.167 20.239 267.927 17.9868 265.169 18.1303C254.248 18.6987 243.491 21.1264 233.365 25.3206C221.698 30.1535 211.097 37.2371 202.167 46.167C193.237 55.0969 186.153 65.6982 181.32 77.3657C177.126 87.4916 174.698 98.2484 174.13 109.169C173.986 111.927 176.239 114.167 179 114.167L265.167 114.167C267.928 114.167 270.167 111.929 270.167 109.167L270.167 23.0004Z",
    fill: "var(--ui-secondary)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_240_9570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4647 101.465C29.4173 103.418 32.5938 103.426 34.4423 101.375C41.7627 93.2505 47.6523 83.9277 51.8465 73.8018C56.6794 62.1343 59.1668 49.6292 59.1668 37.0004C59.1668 24.3716 56.6794 11.8664 51.8465 0.198949C47.6523 -9.92691 41.7627 -19.2498 34.4423 -27.3739C32.5938 -29.4254 29.4173 -29.4169 27.4647 -27.4643L-33.4645 33.4649C-35.4171 35.4175 -35.4171 38.5833 -33.4645 40.5359L27.4647 101.465Z",
    fill: "var(--ui-accent)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.68 35.72L80.424 36.68H82.648L82.408 35.72C82.2693 35.1973 82.1253 34.6427 81.976 34.056C81.8373 33.4693 81.6987 32.904 81.56 32.36H81.496C81.368 32.9147 81.2347 33.4853 81.096 34.072C80.968 34.648 80.8293 35.1973 80.68 35.72ZM76.904 41L80.168 30.568H83L86.264 41H83.768L83.128 38.52H79.944L79.304 41H76.904ZM90.0439 41.192C89.0625 41.192 88.2732 40.824 87.6759 40.088C87.0892 39.3413 86.7959 38.3227 86.7959 37.032C86.7959 36.168 86.9505 35.4267 87.2599 34.808C87.5799 34.1787 87.9905 33.6987 88.4919 33.368C89.0039 33.0373 89.5372 32.872 90.0919 32.872C90.5292 32.872 90.8972 32.9467 91.1959 33.096C91.4945 33.2453 91.7772 33.448 92.0439 33.704L91.9479 32.488V29.784H94.2999V41H92.3799L92.2199 40.216H92.1559C91.8785 40.4933 91.5532 40.728 91.1799 40.92C90.8065 41.1013 90.4279 41.192 90.0439 41.192ZM90.6519 39.272C90.9079 39.272 91.1372 39.2187 91.3399 39.112C91.5532 39.0053 91.7559 38.8187 91.9479 38.552V35.304C91.7452 35.112 91.5265 34.9787 91.2919 34.904C91.0679 34.8293 90.8492 34.792 90.6359 34.792C90.2625 34.792 89.9319 34.9733 89.6439 35.336C89.3559 35.688 89.2119 36.2427 89.2119 37C89.2119 37.7787 89.3345 38.3547 89.5799 38.728C89.8359 39.0907 90.1932 39.272 90.6519 39.272ZM96.3838 41V33.064H98.3038L98.4638 34.088H98.5278C98.8584 33.7573 99.2104 33.4747 99.5838 33.24C99.9571 32.9947 100.405 32.872 100.928 32.872C101.493 32.872 101.946 32.9893 102.288 33.224C102.64 33.448 102.917 33.7733 103.12 34.2C103.472 33.8373 103.845 33.528 104.24 33.272C104.634 33.0053 105.093 32.872 105.616 32.872C106.469 32.872 107.093 33.16 107.488 33.736C107.893 34.3013 108.096 35.08 108.096 36.072V41H105.744V36.376C105.744 35.8 105.664 35.4053 105.504 35.192C105.354 34.9787 105.109 34.872 104.768 34.872C104.373 34.872 103.92 35.128 103.408 35.64V41H101.056V36.376C101.056 35.8 100.976 35.4053 100.816 35.192C100.666 34.9787 100.421 34.872 100.08 34.872C99.6851 34.872 99.2371 35.128 98.7358 35.64V41H96.3838ZM110.103 41V33.064H112.455V41H110.103ZM111.271 31.896C110.876 31.896 110.556 31.784 110.311 31.56C110.065 31.336 109.943 31.0373 109.943 30.664C109.943 30.2907 110.065 29.992 110.311 29.768C110.556 29.544 110.876 29.432 111.271 29.432C111.665 29.432 111.985 29.544 112.231 29.768C112.476 29.992 112.599 30.2907 112.599 30.664C112.599 31.0373 112.476 31.336 112.231 31.56C111.985 31.784 111.665 31.896 111.271 31.896ZM114.524 41V33.064H116.444L116.604 34.072H116.668C117.01 33.752 117.383 33.4747 117.788 33.24C118.204 32.9947 118.679 32.872 119.212 32.872C120.076 32.872 120.7 33.16 121.084 33.736C121.479 34.3013 121.676 35.08 121.676 36.072V41H119.324V36.376C119.324 35.8 119.244 35.4053 119.084 35.192C118.935 34.9787 118.69 34.872 118.348 34.872C118.05 34.872 117.794 34.9413 117.58 35.08C117.367 35.208 117.132 35.3947 116.876 35.64V41H114.524ZM127.076 41V30.568H130.66C131.428 30.568 132.121 30.6747 132.74 30.888C133.369 31.0907 133.87 31.4373 134.244 31.928C134.617 32.4187 134.804 33.0853 134.804 33.928C134.804 34.7387 134.617 35.4053 134.244 35.928C133.87 36.4507 133.374 36.84 132.756 37.096C132.137 37.3413 131.46 37.464 130.724 37.464H129.428V41H127.076ZM129.428 35.592H130.58C131.86 35.592 132.5 35.0373 132.5 33.928C132.5 33.384 132.329 33 131.988 32.776C131.646 32.552 131.156 32.44 130.516 32.44H129.428V35.592ZM139.479 41.192C138.807 41.192 138.173 41.032 137.575 40.712C136.989 40.3813 136.514 39.9067 136.151 39.288C135.789 38.6587 135.607 37.9067 135.607 37.032C135.607 36.1467 135.789 35.3947 136.151 34.776C136.514 34.1573 136.989 33.688 137.575 33.368C138.173 33.0373 138.807 32.872 139.479 32.872C140.151 32.872 140.781 33.0373 141.367 33.368C141.954 33.688 142.429 34.1573 142.791 34.776C143.154 35.3947 143.335 36.1467 143.335 37.032C143.335 37.9067 143.154 38.6587 142.791 39.288C142.429 39.9067 141.954 40.3813 141.367 40.712C140.781 41.032 140.151 41.192 139.479 41.192ZM139.479 39.288C139.959 39.288 140.322 39.0853 140.567 38.68C140.813 38.264 140.935 37.7147 140.935 37.032C140.935 36.3387 140.813 35.7893 140.567 35.384C140.322 34.9787 139.959 34.776 139.479 34.776C138.989 34.776 138.621 34.9787 138.375 35.384C138.141 35.7893 138.023 36.3387 138.023 37.032C138.023 37.7147 138.141 38.264 138.375 38.68C138.621 39.0853 138.989 39.288 139.479 39.288ZM144.946 41V33.064H146.866L147.026 34.456H147.09C147.378 33.9227 147.725 33.528 148.13 33.272C148.536 33.0053 148.941 32.872 149.346 32.872C149.57 32.872 149.757 32.888 149.906 32.92C150.056 32.9413 150.184 32.9787 150.29 33.032L149.906 35.064C149.768 35.0213 149.629 34.9893 149.49 34.968C149.362 34.9467 149.213 34.936 149.042 34.936C148.744 34.936 148.429 35.048 148.098 35.272C147.778 35.4853 147.512 35.8587 147.298 36.392V41H144.946ZM154.377 41.192C153.396 41.192 152.692 40.9093 152.265 40.344C151.849 39.7787 151.641 39.0373 151.641 38.12V34.904H150.553V33.16L151.769 33.064L152.041 30.952H153.993V33.064H155.897V34.904H153.993V38.088C153.993 38.536 154.084 38.8613 154.265 39.064C154.457 39.256 154.708 39.352 155.017 39.352C155.145 39.352 155.273 39.336 155.401 39.304C155.54 39.272 155.663 39.2347 155.769 39.192L156.137 40.904C155.935 40.968 155.684 41.032 155.385 41.096C155.097 41.16 154.761 41.192 154.377 41.192ZM159.134 41.192C158.408 41.192 157.832 40.9627 157.406 40.504C156.979 40.0347 156.766 39.464 156.766 38.792C156.766 37.96 157.118 37.3093 157.822 36.84C158.526 36.3707 159.662 36.056 161.23 35.896C161.208 35.544 161.102 35.2667 160.91 35.064C160.728 34.8507 160.419 34.744 159.982 34.744C159.651 34.744 159.315 34.808 158.974 34.936C158.632 35.064 158.27 35.24 157.886 35.464L157.038 33.912C157.539 33.6027 158.072 33.352 158.638 33.16C159.214 32.968 159.811 32.872 160.43 32.872C161.443 32.872 162.222 33.1653 162.766 33.752C163.31 34.3387 163.582 35.24 163.582 36.456V41H161.662L161.502 40.184H161.438C161.107 40.4827 160.75 40.728 160.366 40.92C159.992 41.1013 159.582 41.192 159.134 41.192ZM159.934 39.368C160.2 39.368 160.43 39.3093 160.622 39.192C160.824 39.064 161.027 38.8987 161.23 38.696V37.304C160.398 37.4107 159.822 37.5813 159.502 37.816C159.182 38.04 159.022 38.3067 159.022 38.616C159.022 38.872 159.102 39.064 159.262 39.192C159.432 39.3093 159.656 39.368 159.934 39.368ZM167.731 41.192C166.921 41.192 166.355 40.952 166.035 40.472C165.726 39.9813 165.571 39.336 165.571 38.536V29.784H167.923V38.632C167.923 38.8773 167.966 39.048 168.051 39.144C168.147 39.24 168.243 39.288 168.339 39.288C168.393 39.288 168.435 39.288 168.467 39.288C168.51 39.2773 168.563 39.2667 168.627 39.256L168.915 41C168.787 41.0533 168.622 41.096 168.419 41.128C168.227 41.1707 167.998 41.192 167.731 41.192Z",
    fill: "var(--ui-light-text)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 27.8,
    r: 1.8,
    fill: "var(--ui-on-accent)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 35,
    r: 1.8,
    fill: "var(--ui-on-accent)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 42.1999,
    r: 1.8,
    fill: "var(--ui-on-accent)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 35,
    r: 1.8,
    fill: "var(--ui-on-accent)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 27.8,
    r: 1.8,
    fill: "var(--ui-on-accent)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.2,
    cy: 35,
    r: 1.8,
    fill: "var(--ui-on-accent)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 42.1999,
    r: 1.8,
    fill: "var(--ui-on-accent)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.2,
    cy: 27.8,
    r: 1.8,
    fill: "var(--ui-on-accent)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.2,
    cy: 42.1999,
    r: 1.8,
    fill: "var(--ui-on-accent)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_240_9570",
    x: 100.123,
    y: -51.8762,
    width: 244.043,
    height: 244.043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_240_9570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_240_9570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_240_9570",
    x: -108.929,
    y: -98.9209,
    width: 242.096,
    height: 279.843,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_240_9570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_240_9570",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPortalMenuHero);
export default __webpack_public_path__ + "static/media/Admin Portal Menu Hero.288fc6bd38f4ec98e7fb6698cb414372.svg";
export { ForwardRef as ReactComponent };